import { jsx as _jsx } from "react/jsx-runtime";
import { usePrefillDataCookie } from "@/components/contacting/ContactForm/usePrefillDataCookie";
import { useContactFormSection } from "@/contexts/contact";
import { useGDPR } from "@/contexts/GDPR";
import { useSendLead } from "@/hooks";
import { useSendSavedSearchOptIn } from "@/hooks/useSendSavedSearchOptIn";
import { useBrandContext } from "@/shared/contexts";
import { useEffect } from "react";
import { ContactForm } from "./ContactForm";
import { ContactFormError } from "./ContactFormError";
export const ContactFormWithLead = ({ close, av_zone, isModal, onError, contactFormRootTestId, }) => {
    const contactFormSection = useContactFormSection();
    const { handleSubmit, loading, postLeadError } = useSendLead();
    const { handleSavedSearchOptIn } = useSendSavedSearchOptIn();
    const { setPrefillDataCookie } = usePrefillDataCookie();
    //check if the consent is given for set the cookie
    const { cmp: { type: GDPRType }, } = useBrandContext();
    const cookieConsent = GDPRType === "didomi" ? "personnali-FDjDrWrj" : "Contact Auto-fill";
    const { purposesConsent } = useGDPR();
    const handleSubmitAndClose = async (data) => {
        const filteredData = { ...data };
        delete filteredData.suggestPrice;
        await handleSubmit(filteredData, av_zone);
        await handleSavedSearchOptIn(data);
        if (purposesConsent.includes(cookieConsent))
            setPrefillDataCookie(data);
        close();
    };
    useEffect(() => {
        if (postLeadError && onError) {
            onError();
        }
    }, [postLeadError, onError]);
    return postLeadError ? (_jsx(ContactFormError, { close: close })) : (_jsx(ContactForm, { contactFormDatas: contactFormSection, loading: loading, rootTestId: contactFormRootTestId, onSubmit: handleSubmitAndClose, avZone: av_zone, isModal: isModal }));
};
